import { makeObservable } from 'mobx';

import { EntryTranslationFieldData } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';

export class TranslationList extends List<EntryTranslationFieldData, EntryTranslationFieldData> {
    protected readonly identifiableFieldName: string = 'fieldName';

    constructor(params?: EntryTranslationFieldData[]) {
        super(params);
        makeObservable(this);
    }

    protected create(params: EntryTranslationFieldData): EntryTranslationFieldData {
        return params;
    }
}
